import styles from "./footer.module.css";
import logoIcon from "../../assets/Icon.png";
import { useNavigate } from "react-router";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.footer}>
      <div className={styles.footer_image}>
        <h2>
          <a href="" target="_blank" rel="noopener noreferrer"></a>
        </h2>
      </div>
      <div className={`${styles.footer_content} container`}>
        <div>
          <div className={styles.logo_holder}>
            <img src={logoIcon} alt="Logo Icon" />
            <h3>M G FITNESS</h3>
          </div>
          <p>
            Your fitness journey starts here.
            Building strength, confidence, and health since 2012
          </p>
          <div className={styles.info}>
            <span>Call :</span>
            <p>
              <a href="tel:+919763440018" className={styles.contact_link}>
                +91 97634 40018
              </a>
            </p>
            <span>Email :</span>
            <p>
              <a
                href="mailto:mgfitnesscoach67@gmail.com"
                className={styles.contact_link}
              >
                mgfitnesscoach67@gmail.com
              </a>
            </p>
          </div>
        </div>
        <div>
          <ul>
            <li onClick={() => navigate("/")}>Home</li>
            <li onClick={() => navigate("/contact")}>Contact</li>
          </ul>
        </div>
        <div>
          <div className={styles.footer_icons}>
            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/in/mangesh-ghanekar-553a94189/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-linkedin"></i>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/919763440018?text=Hello%20I%20would%20like%20to%20know%20more%20about%20your%20gym%20services."
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-whatsapp"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
